import { useEffect, useRef, useState } from "react";
import ChatModal, { modalButton } from "./ChatModal";
import MemberPicker from "./MemberPicker";
import { useChat } from "./ChatProvider";

function CreateGroupModal({ onClose, onCreated }) {
  const { me, createGroup } = useChat();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [memberIds, setMemberIds] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const nameRef = useRef(null);

  useEffect(() => nameRef.current?.focus(), []);

  const submit = async (e) => {
    e?.preventDefault();
    if (!name.trim()) return setError("Give the group a name.");
    setSaving(true);
    setError("");
    try {
      const conversation = await createGroup({ name: name.trim(), description: description.trim(), memberIds });
      onCreated?.(conversation);
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "Couldn't create the group.");
      setSaving(false);
    }
  };

  return (
    <ChatModal
      title="New group"
      onClose={onClose}
      footer={
        <>
          <button type="button" className={modalButton.secondary} onClick={onClose}>
            Cancel
          </button>
          <button type="button" className={modalButton.primary} onClick={submit} disabled={saving || !name.trim()}>
            {saving ? "Creating…" : `Create group${memberIds.length ? ` (${memberIds.length + 1})` : ""}`}
          </button>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-3">
        <div>
          <label htmlFor="chat-group-name" className="block text-sm font-medium mb-1">
            Group name
          </label>
          <input
            id="chat-group-name"
            ref={nameRef}
            maxLength={120}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Survey Ops"
            className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
          />
        </div>
        <div>
          <label htmlFor="chat-group-description" className="block text-sm font-medium mb-1">
            Description <span className="text-gray-400 font-normal">(optional)</span>
          </label>
          <input
            id="chat-group-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
          />
        </div>
        <div>
          <p className="text-sm font-medium mb-1">Add members</p>
          <MemberPicker selected={memberIds} onChange={setMemberIds} exclude={me ? [me.id] : []} />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </form>
    </ChatModal>
  );
}

export default CreateGroupModal;
